import { Icon, DatePicker } from '@repo/ui';
import { cn, dateUtil } from '@xtnd/web/shared';
import { DateFormat } from '@xtnd/web/shared/utils/format';

interface EditableDeadlineProps {
  label: string;
  isEditing: boolean;
  value: Date | string | null | undefined; // Current SAVED value (can be string from API)
  editedValue: Date | null | undefined; // Current EDITING value
  onStartEdit: () => void;
  onChange: (date: Date | null) => void; // DatePicker usually returns Date | null
  onSave: () => void;
  onClear: () => void;
  isSaving: boolean;
  canEdit: boolean;
  error?: string;
  minDate?: Date;
  maxDate?: Date;
  placeholder?: string;
  className?: string;
}

export const EditableDeadline = ({
  label,
  isEditing,
  value,
  editedValue,
  onStartEdit,
  onChange,
  onSave,
  onClear,
  isSaving,
  canEdit,
  error,
  minDate,
  maxDate,
  placeholder = 'Set deadline',
  className,
}: EditableDeadlineProps) => {
  return (
    <div className={cn('space-y-1', className)}>
      <span className="text-xs text-gray-500 font-bold tracking-wider">{label}</span>
      {isEditing ? (
        <div className="flex items-start gap-2 w-48">
          <DatePicker
            mode="single"
            value={editedValue}
            onChange={onChange}
            format="MM/dd/yyyy"
            min={minDate}
            max={maxDate}
            error={error}
            onClose={onSave}
            disabled={isSaving}
            allowClear
            onClear={onClear}
            className="w-full bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white"
          />
        </div>
      ) : (
        <div className="flex items-center justify-between p-2 rounded border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 h-[38px] w-full group">
          {value ? (
            <strong
              className={`${isSaving ? 'opacity-50' : ''} text-sm text-gray-800 dark:text-gray-200`}
            >
              {dateUtil?.formatDate(value, DateFormat.US)}
            </strong>
          ) : (
            <span className="text-sm text-gray-500 italic">{canEdit ? placeholder : '-'}</span>
          )}
          {canEdit && (
            <Icon
              name="HiPencil"
              className="text-gray-500 cursor-pointer hover:text-gray-900 dark:hover:text-white"
              onClick={onStartEdit}
            />
          )}
        </div>
      )}
    </div>
  );
};
